<template>
  <div id="moneyRain">
    <div
      v-for="item in moneyList"
      :key="item.id"
      :class="['money', item.type]"
      :style="item.style"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

interface MoneyItem {
  id: number;
  type: string;
  style: Record<string, string>;
}

const moneyList = ref<MoneyItem[]>([]);
const moneyTypes = ['money1', 'money2', 'money3', 'money4'];
let idCounter = 0;
let spawnInterval: number;

function spawnMoney() {
  const type = moneyTypes[Math.floor(Math.random() * moneyTypes.length)];
  const left = Math.random() * 100;
  const delay = 0;
  const duration = 6 + Math.random() * 4; // 6s to 10s
  const rotation = Math.random() > 0.5 ? 720 : -720;

  const item: MoneyItem = {
    id: idCounter++,
    type,
    style: {
      left: `${left}vw`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      '--rotation': `${rotation}deg`,
    },
  };

  moneyList.value.push(item);

  // Remove item after animation finishes
  setTimeout(() => {
    moneyList.value = moneyList.value.filter(i => i.id !== item.id);
  }, duration * 1000);
}

onMounted(() => {
  spawnInterval = window.setInterval(() => {
    for (let i = 0; i < 15; i++) {
      spawnMoney();
    }
  }, 300); // Add 3 every 300ms
});

onBeforeUnmount(() => {
  clearInterval(spawnInterval);
});
</script>

<style scoped>
#moneyRain {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.money {
  position: absolute;
  top: -100px;
  background-image: url('@/assets/collect/money.png');
  background-size: contain;
  background-repeat: no-repeat;
  animation-name: fallAndSpin;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  will-change: transform;
}

.money1 {
  width: 30px;
  height: 20px;
}

.money2 {
  width: 40px;
  height: 25px;
}

.money3 {
  width: 50px;
  height: 30px;
}

.money4 {
  width: 60px;
  height: 35px;
}

@keyframes fallAndSpin {
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(110vh) rotate(var(--rotation, 720deg));
    opacity: 1;
  }
}
</style>
